import alertPng from '@/../img/alert.png';
import superhostPng from '@/../img/superhost.png';
import { datasetSubtypeLabelsProper } from '@/constants';
import { getPlatformFriendlyName } from '@/utils/string-utils';
import { useState } from 'react';
import styled from 'styled-components';
import { DetailsInfoDisplay } from '../details-info-display';
import { Value } from '../details-info-mod-styles';
import { ListingInfoTitle } from './listing-info-title';

// TODO: Let's put these all in the same place with datasetSubTypes
const HOST = 'Host';
const STR_LICENSE_DISPLAYED = 'STR License displayed';
// const LTR_LICENSE_DISPLAYED = 'LTR License displayed';
const OCCUPANCY_ADVERTISED = 'Occupancy advertised';
const LISTING_CREATED_ON = 'First seen';
const BEDROOM_ADVERTISED = 'Bedroom advertised';
const RENTAL_STRUCTURE = 'Rental Structure';
const UNIT_TYPE = 'Unit type';

const NO_DISPLAY_VALUE_MSG = 'Unknown';
const NO_LICENSE_MSG = 'None';

const StyledValue = styled(Value)`
  border-bottom: ${(props) =>
    props.isSuperhost ? '2px solid rgba(89, 126, 247, 0.5)' : 'none'};
`;

function HostDisplay({ listing }) {
  return (
    <StyledValue isSuperhost={listing?.hostInfo?.isSuperhost || false}>
      {listing?.hostInfo?.name || listing?.hostName || NO_DISPLAY_VALUE_MSG}
    </StyledValue>
  );
}

function Title(props) {
  const {
    listing,
    platformIcons,
    showPdf,
    enableListingPopover,
    setActiveDeckardId,
  } = props;

  const openListingUrl = (listingUrl) => {
    window.open(listingUrl, '_blank');
  };

  return (
    <ListingInfoTitle
      cIdx={props.cIdx}
      listing={listing}
      onUrlClick={() => openListingUrl(listing.listingUrl || listing.url)}
      onPdfClick={showPdf}
      title={`${getPlatformFriendlyName(listing.platform, platformIcons)} ${
        listing.id || ''
      }`}
      setActiveDeckardId={setActiveDeckardId}
      enableListingPopover={enableListingPopover}
    />
  );
}

const maybeAlert = (isAlert) =>
  isAlert && <img src={alertPng} alt="Potential issue" />;
const maybeSuperhost = (isSuperhost) =>
  isSuperhost && <img src={superhostPng} alt="superhost" />;

export function ConstructedListingDetails(props) {
  const {
    currentPlatformListings,
    showPdf,
    rentalStructure,
    unitType,
    platformIcons,
  } = props;

  const rentalStructureLabel =
    datasetSubtypeLabelsProper.rentalStructure[rentalStructure];
  const unitTypeLabel = datasetSubtypeLabelsProper.unitType[unitType];

  const [activeDeckardId, setActiveDeckardId] = useState('');

  return (
    <div>
      {currentPlatformListings.map((listing) => (
        <DetailsInfoDisplay
          key={listing.id}
          CustomTitle={
            <Title
              listing={listing}
              platformIcons={platformIcons}
              showPdf={showPdf}
              setActiveDeckardId={setActiveDeckardId}
              enableListingPopover={listing.deckardid === activeDeckardId}
            />
          }
          left={[
            [
              HOST,
              <HostDisplay key="host-display" listing={listing} />,
              maybeSuperhost(listing?.hostInfo?.isSuperhost),
            ],
            [
              STR_LICENSE_DISPLAYED,
              listing?.strLicenseDisplayed || NO_LICENSE_MSG,
              maybeAlert(!listing?.strLicenseDisplayed),
            ],
            [UNIT_TYPE, unitTypeLabel],
          ]}
          right={[
            // [MINIMUM_STAY, listing?.minimumStay, maybeAlert(false)],
            [
              BEDROOM_ADVERTISED,
              listing?.bedroomsAdvertised,
              maybeAlert(false),
            ],
            [
              OCCUPANCY_ADVERTISED,
              listing?.occupancyAdvertised,
              // TODO: Alerts should be determined by violation values
              maybeAlert(
                listing?.bedroomsAdvertised < listing?.occupancyAdvertised / 2
              ),
            ],
            [RENTAL_STRUCTURE, rentalStructureLabel],
            [LISTING_CREATED_ON, listing?.createdOn, maybeAlert(false)],
          ]}
        />
      ))}
    </div>
  );
}
